import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import blogs from "./blogData";
import Cosection from '../components/Cosections';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';
import { 
  Container, 
  Grid, 
  Typography, 
  Card, 
  CardMedia, 
  CardContent,
  Button,
  Box,
  Divider
} from "@mui/material";
import "./Blogpost.css";

const BlogPost = () => {
  const { id } = useParams();
  const blog = blogs.find((b) => b.id === id);

  // Scroll to top on component mount and when ID changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!blog) return <h2>Blog Not Found</h2>;

  const worthReading = blogs.filter((b) => b.id !== blog.id).slice(0, 5);

  return (
    <>
        <Navigation />
      <Container className="blogpost-container">
        {/* Back Button */}
        <Button 
          component={Link} 
          to="/resource" 
          variant="contained" 
          className="back-button"
          startIcon={<span style={{ fontSize: '1.2rem' }}>←</span>}
        >
          Back to Resources
        </Button>

        {/* Rest of your component remains the same */}
        <Grid container spacing={4}>
          {/* Main Blog Content */}
          <Grid item xs={12} md={12} className="blogpost-content">
            <CardMedia
              component="img"
              height="300"
              image={blog.image}
              alt={blog.title}
              className="blogpost-image"
            />
            <Typography variant="h2" className="blogpost-title">{blog.title}</Typography>
            <Typography variant="body2" className="blogpost-date">{blog.date}</Typography>
            
            {/* Blog Content */}
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              components={{
                p: ({ node, ...props }) => <Typography variant="body1" {...props} />,
                h1: ({ node, ...props }) => <Typography variant="h4" {...props} />,
                h2: ({ node, ...props }) => <Typography variant="h5" {...props} />,
              }}
            >
              {blog.content}
            </ReactMarkdown>
          </Grid>
        </Grid>

        {/* Worth Reading Section */}
        <Box sx={{ mt: 8, mb: 4 }}>
          <Divider sx={{ mb: 4 }} />
          <Typography 
            variant="h4" 
            className="worth-reading-title"
            sx={{
              position: 'relative',
              display: 'inline-block',
              '&:after': {
                content: '""',
                position: 'absolute',
                width: '70%',
                height: '4px',
                bottom: '-10px',
                left: '15%',
                backgroundColor: 'primary.main',
                borderRadius: '2px'
              }
            }}
          >
            More Worth Reading
          </Typography>
          
          <Grid container spacing={3} sx={{ mt: 3 }}>
            {worthReading.map((blog) => (
              <Grid item xs={12} sm={6} md={4} key={blog.id}>
                <Card 
                  component={Link} 
                  to={`/blog/${blog.id}`} 
                  className="worth-reading-card"
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    textDecoration: 'none',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: 6
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    height="140"
                    image={blog.image}
                    alt={blog.title}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h6" component="div">
                      {blog.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {blog.date}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
      <Cosection />
                  <Scrolltop />
                        <WhatsAppChatButton />
                               <Footer />
    </>
  );
};

export default BlogPost;